// Facets.js
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Checkbox, FormControlLabel, Divider } from '@mui/material';

const Facets = ({ facets, selectedFacets, onFacetChange }) => {
  const facetDisplayNames = {
    courseName: 'Course Name',
    subjectName: 'Subject',
    semester: 'Semester',
    bookType: 'Document Type',
    publisherName: 'Publisher',
    bookLanguage: 'Language',
  };

  return (
    <Box>
      {Object.entries(facets).map(([facetName, facetValues]) => (
        <Box
          key={facetName}
          sx={{
            marginBottom: '16px',
            padding: '16px',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            border: '1px solid #ddd',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}>
            {facetDisplayNames[facetName] || facetName}
          </Typography>
          <Divider sx={{ mb: 1 }} />

          {Object.entries(facetValues).map(([value, count]) => (
            <FormControlLabel
              key={value}
              control={
                <Checkbox
                  checked={selectedFacets[facetName]?.includes(value) || false}
                  onChange={() => onFacetChange(facetName, value)}
                  sx={{
                    color: '#007bff',
                    '&.Mui-checked': { color: '#007bff' },
                    marginRight: '8px',  // Add margin to the right of the checkbox to create space between checkbox and text
                  }}
                />
              }
              label={
                <Typography sx={{ fontSize: '0.875rem', color: '#333' }}>
                  {value} ({count})
                </Typography>
              }
              sx={{
                display: 'inline-flex',   // Ensure the checkbox and text are inline
                alignItems: 'center',     // Vertically center the checkbox and text
                marginBottom: '8px',      // Optional: Add some spacing between items
              }}
            />

          ))}
        </Box>
      ))}
    </Box>
  );
};

Facets.propTypes = {
  facets: PropTypes.object.isRequired,
  selectedFacets: PropTypes.object.isRequired,
  onFacetChange: PropTypes.func.isRequired,
};

export default Facets;
